import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import withRouter from 'with-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TranslateOutlined from '@mui/icons-material/TranslateOutlined';
import InputOutlined from '@mui/icons-material/InputOutlined';
import EditOutlined from '@mui/icons-material/EditOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import { withSnackbar } from '../utils/withSnackbar';
import { Alert } from '@mui/material';

import $ from 'jquery';
import Redactor from './RedactorWrapper';
import RedactorX from './RedactorXWrapper';
import ErrorBoundary from './ErrorBoundary';
import { UpdateAppPermissionsSnackbar } from './UpdateAppPermissionsDialog';
import API from '../api/api';

class RichTextEditor extends React.Component {
  self = this;

  constructor(props) {
    super(props);


    this.state = {
      value: props.value,
      toolbarRowsClass: 'toolbar-rows-1',
      sourceMode: false,
      loading: false,
      focused: false,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    window.$ = window.jQuery = $;
  }

  componentWillUnmount() {
    $(window).unbind('resize', this.checkResize);
  }

  componentWillReceiveProps(newProps) {
    if(this.props.value !== newProps.value) {
      this.setState({
        value: newProps.value,
      });
    }
    if(this.props.focused !== newProps.focused) {
      this.setState({
        focused: newProps.focused,
      });
    }
  }

  onStarted = () => {
    this.props.onLoaded && this.props.onLoaded();
  }

  onChange = (data) => {

    if(!this.props.isPending && data !== this.props.value) {
      this.props.onChange({
        target: {
          value: data
        }
      });
    }
  }

  onFocus = (evt) => {
    let rows, $editor, $toolbar;
    if(this.props.version === 'v2') 
    { // REDACTORX
      // the id is used as a CSS selector: item and field ids must be CSS-safe (dashes only, no dots or colons)
      $editor = window.RedactorX(`#${this.props.id}`);
      $editor.toolbar.setActive();
      //if(this.props.id.indexOf('source') !== -1) {
        //let $sourceEditor = window.RedactorX(`#${this.props.id}`);
        //$sourceEditor?.editor?.setBlur();
      //}
    } 
    else
    { // REDACTOR
      $toolbar = $(`#${this.props.id}-toolbar`);
      $editor = $(`#${this.props.id}`);
      $toolbar.addClass('in');
      rows = Math.floor($toolbar.height() / $toolbar.find('.re-html').outerHeight());
      $editor.addClass('toolbar-rows-' + rows);
      this.setState({
        toolbarRowsClass: `toolbar-rows-${rows}`,
      });
    }
  };

  onBlur = (evt) => {
    let isSourceMode, isEmpty;
    if(this.props.version === 'v2') 
    { // REDACTORX
      //let $editor = window.RedactorX(`#${this.props.id}`);
      //isSourceMode = $editor.source.is();
      //isEmpty = $editor.editor.isEmpty();
      //$editor.toolbar.unsetActive();
    } 
    else
    { // REDACTOR
      isSourceMode = $(`#${this.props.id}`).redactor('editor.isSourceMode');
      isEmpty = $(`#${this.props.id}`).redactor('editor.isEmpty');
      if(!isSourceMode) {
        let $toolbar = $(`#${this.props.id}-toolbar`);
        $toolbar.removeClass('in');
      }
    }    
  };

  onSourceOpened = (evt) => {
    if(this.props.id.indexOf('target') !== -1) {
      let newId = this.props.id.replace('target', 'source');

      if(this.props.version === 'v2') 
      { // REDACTORX
        let $sourceEditor = window.RedactorX(`#${newId}`);
        let $targetEditor = window.RedactorX(`#${this.props.id}`);
        if($sourceEditor) {
          $sourceEditor.source.open();
          $sourceEditor.editor.setBlur();
          $targetEditor.container.setFocus();
          $targetEditor.editor.setFocus('start');
        }
      }
      else
      { // REDACTOR
        let $sourceEditor = $(`#${newId}`);
        if($sourceEditor.length > 0) {
          $sourceEditor.attr('disabled', 'disabled');
          $sourceEditor.redactor('disableReadOnly');
          $sourceEditor.redactor('module.source.show');
          $sourceEditor.redactor('enableReadOnly');        
        }
      }
    }
    this.setState({
      sourceMode: true,
    });
  };

  onSourceClosed = (evt) => {
    let $sourceEditor;
    let $targetEditor;
    if(this.props.id.indexOf('target') !== -1) {
      let newId = this.props.id.replace('target', 'source');
      if(this.props.version === 'v2')
      { // REDACTORX
        $sourceEditor = window.RedactorX(`#${newId}`);
        $targetEditor = window.RedactorX(`#${this.props.id}`);
        if($sourceEditor) {
          $sourceEditor.source.close();
          $targetEditor.container.setFocus();
          $targetEditor.editor.setFocus('start');
          //$sourceEditor.editor.setBlur();
        }      
      }
      else
      { // REDACTOR
        $sourceEditor = $(`#${newId}`);
        if($sourceEditor.length > 0) {
          $sourceEditor.redactor('disableReadOnly');
          $sourceEditor.redactor('module.source.hide');
          $sourceEditor.redactor('enableReadOnly');        
        }
      }

    }
    this.setState({
      sourceMode: false,
    });
  };




  onUseImageUpload = () => {
    // Hier Snackbar triggern, wenn die app keine schreib und leserechte hat!

    if(this.props.access_rights && this.props.access_rights.access_lack && this.props.access_rights.access_lack.length > 0) {
      this.props.enqueueSnackbar('In order to use the upload feature, you have to grand langify more permissions.', {
        variant: 'error',
        persist: true,
        //action: this.onUpdate,
        //hideIconVariant: true,
        //iconVariant: <ErrorOutlineOutlinedIcon />,
        content: (key, message) => <UpdateAppPermissionsSnackbar
          message={message}
        />
      });
    }
  }

  checkResize = (e) => {
    let $toolbar = $(`#${this.props.id}-toolbar`);
    let rows = Math.floor($toolbar.height() / $toolbar.find('.re-html').outerHeight());
    if(undefined !== rows) {
      this.setState({
        toolbarRowsClass: `toolbar-rows-${rows}`
      });
    }
  };

  render() {
    const {
      densed,
      id,
      config,
      readOnly,
      hasImportOriginalBtn,
      hasAutoTranslateBtn,
      label,
      onChange,
      error,
      forceUpdate,
      triggerDiscardChanges
    } = this.props;

    const {
      value,
      toolbarRowsClass,
      sourceMode,
      loading,
      focused
    } = this.state;

    const ErroMessage = <Box sx={styles.errorRoot}>
      <Box component="textarea" className={classNames(!onChange ? 'readonly' : '')} sx={styles.errorValue} value={value} onChange={(e) => onChange ? this.onChange(e.target.value) : null} readOnly={!onChange} />
      <Box component="p" sx={styles.errorNotice}>NOTICE: The richtext editor could not load, due to an invalid HTML structure in the content.</Box>
    </Box>

    const redactorProps = {
      id: id,
      defaultValue: value,
      config: config,
      readOnly: readOnly,
      focused: focused,
      onStarted: this.onStarted,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onChange: onChange ? this.onChange : null,
      onSourceOpened: this.onSourceOpened,
      onSourceClosed: this.onSourceClosed,
      onUseImageUpload: this.onUseImageUpload
    }

    return (
      <ErrorBoundary msg={ErroMessage}>
        <Box className={classNames(
          'ly-editor',
          readOnly ? 'read-only' : toolbarRowsClass,
          sourceMode ? 'source-mode' : '',
          densed ? 'densed' : '',
          this.props.version === 'v2' ? '_redactorx' : '_redactor',
          error ? 'error' : false,
        )} sx={styles.root}>
          <Box sx={styles.outlineContainer}>
            <Box sx={styles.placeholderBox} />

            {label &&
              <Typography className='ly-editor-label' sx={styles.label} variant="caption" gutterBottom>
                {label}
              </Typography>
            }

            {(!this.props.isPending) &&
              <React.Fragment>
                {this.props.version === 'v2' ?
                  <RedactorX {...redactorProps} forceUpdate={forceUpdate} triggerDiscardChanges={triggerDiscardChanges}/>
                :
                  <Redactor {...redactorProps} />
                }
                {loading &&
                  <CircularProgress style={{color: 'currentColor', position: 'absolute', left: '50%', top: '50%', margin: '-20px 0 0 -20px'}} />
                }
              </React.Fragment>
            }

          </Box>
        </Box>
      </ErrorBoundary>
    )
  }
}

const styles = {
  root: {
    position: 'relative',
    minHeight: 300,
  },
  placeholderBox: {
    border: 'solid 1px',
    borderColor: 'divider',
    borderRadius: '4px',
    height: '100%',
    position: 'absolute',
    width: '100%',
    zIndex: -1,
  },
  outlineContainer: {
  },
  /**
   * Das Label unterbricht die Feldumrandung und braucht dafür eine eigene
   * Fläche. Die kam vorher aus einem hartcodiert weissen :before-Streifen in
   * index.css — im Dark Mode lag das Label dadurch halb auf hellem, halb auf
   * dunklem Grund. `background.paper` ist die modusrichtige Übersetzung des
   * bisherigen Weiss und entspricht der Fläche des Editors darunter.
   *
   * Farbe von `text.disabled` auf `text.secondary`: erstere ergab selbst im
   * Light-Modus nur 2.68:1 und riss AA für kleinen Text. `text.secondary`
   * liefert 5.74:1 im Light und rund 9:1 im Dark.
   */
  label: {
    position: 'absolute',
    zIndex: 1,
    left: '10px',
    top: '-8px',
    display: 'inline-block',
    padding: '0 4px',
    borderRadius: '4px',
    backgroundColor: 'background.paper',
    color: 'text.secondary'
  },
  editor: {
    backgroundColor: 'background.paper',
    padding: '0 8px',
    margin: 0,
    height: 300
  },
  buttonLayer: {
    position: 'absolute',
    margin: 'auto',
    zIndex: 9,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: 250,
    height: 65,
    textAlign: 'center'
  },
  autoTranslateBtn: {
    width: 200,
  },
  importOriginalBtn: {
    marginTop: '8px',
    width: 200,
  },
  margin: {
    margin: '6px'
  },
  errorRoot: {
    border: 'solid 1px',
    borderColor: 'divider',
    borderRadius: '4px',
    minHeight: 300,
    position: 'relative',
    width: '100%',
    overflow: 'hidden'
  },
  errorValue: {
    padding: '0 8px',
    color: 'text.primary',
    backgroundColor: 'transparent',
    minHeight: 300,
    width: '100%',
    overflow: 'scroll',
    border: 'none',
    '&.readonly': {
      color: 'text.disabled',
    }
  },
  errorNotice: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    margin: '4px',
    padding: '8px 8px',
    color: 'text.secondary',
    backgroundColor: 'surfaceRecessed',
    border: 'solid 1px',
    borderColor: 'divider',
    borderRadius: '3px',
  },
  wrapper: (theme) => ({
    margin: theme.spacing(1),
    position: 'relative',
  }),
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
};

RichTextEditor.defaultProps = {
  value: '',
  isPending: false
};

RichTextEditor.propTypes = {
  value: PropTypes.string,
  isPending: PropTypes.bool
};


const mapStateToProps = ({ shop, themes, languages }) => ({
  shop: shop,
  themes: themes,
  languages: languages,
  editLanguage: shop.shop.edit_language,
  access_rights: shop.shop.access_rights,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withSnackbar(RichTextEditor))));